@if(isLoading) {
  <div>Loading...</div>
} @else {
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
  <p-toast key="message"></p-toast>
  <router-outlet />
}

